var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Box, List, ListItem, ListItemText, Typography } from '@mui/material';
import { setHistorySelectedTime, setTransportConditionSelectedItem } from 'app/actions/map';
import { Autosizer, Scrollbar } from 'app/components';
import { useAsyncAction } from 'app/services';
import { hdopLoad } from 'app/store/map';
import React, { forwardRef, useCallback, useEffect, useImperativeHandle, useMemo, useRef, } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { FixedSizeList } from 'react-window';
function getLastItem(items) {
    return items.length > 0 ? items[items.length - 1] : undefined;
}
const MapTransportConditionList = forwardRef(function MapTransportConditionList(_props, ref) {
    const dispatch = useDispatch();
    const listRef = useRef(null);
    const scrollableNodeRef = useRef(null);
    const mapRef = useSelector((state) => state.map.ref, shallowEqual);
    const conditionItems = useSelector((state) => {
        var _a, _b;
        return ((_b = (_a = state.map.transportSelectedItem) === null || _a === void 0 ? void 0 : _a.conditions) !== null && _b !== void 0 ? _b : []).filter((condition) => condition.type === 'message');
    });
    const conditionSelectedItem = useSelector((state) => state.map.transportConditionSelectedItem);
    const conditionSelectedDatetime = useSelector((state) => state.map.transportConditionSelectedDatetime);
    const checkedType = useSelector((state) => state.map.transportConditionFilterCheckedType);
    const checkedItems = useSelector((state) => state.map.transportConditionFilterCheckedItems);
    const { isHistoryOpen } = useSelector((state) => state.map);
    const { asyncAction: fetchHdopData } = useAsyncAction(hdopLoad);
    const items = useMemo(() => {
        return conditionItems.reduce((accumulator, currentValue) => {
            const messages = currentValue.messages || [];
            const currentElement = Object.assign(Object.assign({}, currentValue), { messages: checkedType !== 'all'
                    ? messages.some((message) => checkedItems.indexOf(message.key) !== -1)
                        ? messages
                        : []
                    : messages });
            if ((currentElement.messages || []).length !== 0) {
                return [...accumulator, currentElement];
            }
            if (checkedItems.indexOf('other:message') !== -1 || checkedType === 'all') {
                return [...accumulator, currentElement];
            }
            return accumulator;
        }, []);
    }, [conditionItems, checkedItems, checkedType]);
    useEffect(() => {
        if (checkedType !== 'all') {
            if (!checkedItems) {
                dispatch(setTransportConditionSelectedItem(getLastItem(items)));
            }
            if (checkedItems && conditionSelectedItem) {
                const selectedIndex = items.findIndex((item) => item.datetime === conditionSelectedItem.datetime);
                if (selectedIndex < 0) {
                    dispatch(setTransportConditionSelectedItem(getLastItem(items)));
                }
            }
        }
        if (checkedItems && listRef.current) {
            const selectedIndex = items.findIndex((item) => (item === null || item === void 0 ? void 0 : item.datetime) === (conditionSelectedItem === null || conditionSelectedItem === void 0 ? void 0 : conditionSelectedItem.datetime));
            if (selectedIndex > 0) {
                setTimeout(() => {
                    var _a;
                    (_a = listRef.current) === null || _a === void 0 ? void 0 : _a.scrollToItem(selectedIndex, 'center');
                }, 100);
            }
        }
    }, [checkedType]);
    const itemSelectedIndex = useMemo(() => {
        if (!conditionSelectedItem) {
            return -1;
        }
        setHistorySelectedTime(conditionSelectedItem === null || conditionSelectedItem === void 0 ? void 0 : conditionSelectedItem.datetime);
        return items.findIndex((item) => (item === null || item === void 0 ? void 0 : item.datetime) === (conditionSelectedItem === null || conditionSelectedItem === void 0 ? void 0 : conditionSelectedItem.datetime));
    }, [items, conditionSelectedItem]);
    const handleItemClick = useCallback((value = null, cb) => {
        var _a, _b, _c, _d;
        if ((value === null || value === void 0 ? void 0 : value.datetime) === (conditionSelectedItem === null || conditionSelectedItem === void 0 ? void 0 : conditionSelectedItem.datetime)) {
            return;
        }
        if (value && !items.some((item) => item.datetime === value.datetime)) {
            return;
        }
        dispatch(setTransportConditionSelectedItem(value));
        if (value && value.data.geodata !== 'ERR' && value.data.lat != null && value.data.lon != null) {
            (_b = (_a = mapRef === null || mapRef === void 0 ? void 0 : mapRef.current) === null || _a === void 0 ? void 0 : _a.handleClosePopup) === null || _b === void 0 ? void 0 : _b.call(_a);
            (_d = (_c = mapRef === null || mapRef === void 0 ? void 0 : mapRef.current) === null || _c === void 0 ? void 0 : _c.handleFlyTo) === null || _d === void 0 ? void 0 : _d.call(_c, [value.data.lat, value.data.lon]);
        }
        if (isHistoryOpen && (value === null || value === void 0 ? void 0 : value.datetime)) {
            dispatch(setHistorySelectedTime(value.datetime));
        }
        if (cb) {
            cb();
        }
    }, [items, conditionSelectedItem === null || conditionSelectedItem === void 0 ? void 0 : conditionSelectedItem.datetime, mapRef, isHistoryOpen, dispatch]);
    useImperativeHandle(ref, () => ({
        handleKeyUp() {
            if (items[itemSelectedIndex - 1]) {
                handleItemClick(items[itemSelectedIndex - 1], () => {
                    var _a;
                    (_a = listRef.current) === null || _a === void 0 ? void 0 : _a.scrollToItem(itemSelectedIndex - 1, 'end');
                });
            }
        },
        handleKeyDown() {
            if (items[itemSelectedIndex + 1]) {
                handleItemClick(items[itemSelectedIndex + 1], () => {
                    var _a;
                    (_a = listRef.current) === null || _a === void 0 ? void 0 : _a.scrollToItem(itemSelectedIndex + 1, 'end');
                });
            }
        },
    }), [items, itemSelectedIndex, handleItemClick]);
    useEffect(() => {
        var _a, _b, _c, _d;
        if (conditionSelectedItem === null || conditionSelectedItem === void 0 ? void 0 : conditionSelectedItem.hdopData) {
            (_b = (_a = mapRef === null || mapRef === void 0 ? void 0 : mapRef.current) === null || _a === void 0 ? void 0 : _a.handleClosePopup) === null || _b === void 0 ? void 0 : _b.call(_a);
            (_d = (_c = mapRef === null || mapRef === void 0 ? void 0 : mapRef.current) === null || _c === void 0 ? void 0 : _c.handleFlyTo) === null || _d === void 0 ? void 0 : _d.call(_c, [conditionSelectedItem.hdopData.lat, conditionSelectedItem.hdopData.lon]);
        }
    }, [conditionSelectedItem, mapRef]);
    useEffect(() => {
        let isMounted = true;
        const processSelection = () => __awaiter(this, void 0, void 0, function* () {
            if (conditionSelectedDatetime) {
                const index = items.findIndex((i) => i.datetime === conditionSelectedDatetime);
                if (index !== -1 && isMounted) {
                    handleItemClick(items[index], () => {
                        var _a;
                        (_a = listRef.current) === null || _a === void 0 ? void 0 : _a.scrollToItem(index, 'center');
                    });
                    return;
                }
            }
            if (items.length > 0 && !conditionSelectedItem && isMounted) {
                handleItemClick(items[items.length - 1], () => {
                    var _a;
                    (_a = listRef.current) === null || _a === void 0 ? void 0 : _a.scrollToItem(items.length - 1, 'end');
                });
            }
        });
        processSelection();
        return () => {
            isMounted = false;
        };
    }, [conditionSelectedDatetime, items.length]);
    const prevCountRef = useRef(undefined);
    useEffect(() => {
        var _a;
        const selectedItem = items[itemSelectedIndex];
        if (selectedItem && (selectedItem.data.hdop > config.messageHdopLimit || selectedItem.data.geodata === 'ERR')) {
            fetchHdopData({
                datetime: selectedItem.datetime,
                parking_time: selectedItem.data.parking_time,
            });
        }
        if (prevCountRef.current != null && prevCountRef.current + 1 === items.length - 1) {
            (_a = listRef.current) === null || _a === void 0 ? void 0 : _a.scrollToItem(items.length - 1, 'end');
        }
        prevCountRef.current = itemSelectedIndex;
    }, [itemSelectedIndex]);
    useEffect(() => {
        if (isHistoryOpen && conditionSelectedItem && listRef.current && items.length > 0) {
            const selectedIndex = items.findIndex((item) => (item === null || item === void 0 ? void 0 : item.datetime) === (conditionSelectedItem === null || conditionSelectedItem === void 0 ? void 0 : conditionSelectedItem.datetime));
            if (selectedIndex >= 0) {
                setTimeout(() => {
                    const list = listRef.current;
                    const scrollableNode = scrollableNodeRef.current;
                    if (list && scrollableNode) {
                        const itemSize = 24;
                        const scrollTop = scrollableNode.scrollTop || 0;
                        const visibleHeight = scrollableNode.clientHeight || 0;
                        const firstVisibleIndex = Math.max(0, Math.floor(scrollTop / itemSize));
                        const lastVisibleIndex = Math.min(items.length - 1, Math.ceil((scrollTop + visibleHeight) / itemSize));
                        if (selectedIndex < firstVisibleIndex || selectedIndex > lastVisibleIndex) {
                            list.scrollToItem(selectedIndex, 'center');
                        }
                    }
                    else if (list) {
                        list.scrollToItem(selectedIndex, 'smart');
                    }
                }, 100);
            }
        }
    }, [isHistoryOpen, conditionSelectedItem === null || conditionSelectedItem === void 0 ? void 0 : conditionSelectedItem.datetime, items]);
    return (React.createElement(Box, { component: 'div', sx: (theme) => ({
            width: '100%',
            height: '100%',
            '.simplebar-offset > div': {
                '&::-webkit-scrollbar': {
                    width: 0,
                },
                '&::-webkit-scrollbar-track': {
                    background: 'transparent',
                    boxShadow: 'none',
                },
                '&::-webkit-scrollbar-thumb': {
                    backgroundColor: 'transparent',
                    boxShadow: 'none',
                },
            },
            '.MuiListItemText-root': {
                display: 'flex',
                margin: theme.spacing(0),
                alignItems: 'center',
                height: '100%',
                position: 'relative',
                flex: 'none',
                '&:nth-of-type(1)': {
                    flex: '0 0 35%',
                    padding: '3px 8px 3px 12px',
                },
                '&:nth-of-type(2)': {
                    flex: '1 1 65%',
                    padding: '3px 12px 3px 8px',
                },
            },
            outline: 'none',
            '.simplebar-container': {
                maxHeight: 'none',
            },
        }) },
        React.createElement(Autosizer, null, ({ height, width }) => (React.createElement(Box, { sx: { height, width } },
            React.createElement(Scrollbar, null, ({ scrollableNodeRef: scrollableRef, contentNodeRef }) => {
                scrollableNodeRef.current = scrollableRef === null || scrollableRef === void 0 ? void 0 : scrollableRef.current;
                return (React.createElement(FixedSizeList, { ref: listRef, height: height, itemSize: 24, overscanCount: 20, itemCount: items.length, innerRef: contentNodeRef, outerRef: scrollableRef, innerElementType: MapTransportConditionListInnerElementType, initialScrollOffset: itemSelectedIndex * 24 > height ? itemSelectedIndex * 24 : 0, itemData: {
                        items,
                        selectedItem: conditionSelectedItem,
                        onClick: handleItemClick,
                    } }, MapTransportConditionListItemRender));
            }))))));
});
const MapTransportConditionListInnerElementType = forwardRef((_a, ref) => {
    var { children, style } = _a, rest = __rest(_a, ["children", "style"]);
    return (React.createElement(List, Object.assign({ ref: ref, style: style, sx: { minHeight: '100%' } }, rest),
        React.createElement(ListItem, { disablePadding: true, sx: (theme) => ({
                position: 'absolute',
                top: '0',
                left: '0',
                width: '100%',
                height: style === null || style === void 0 ? void 0 : style.height,
                minHeight: '100%',
                zIndex: '2',
                pointerEvents: 'none',
                padding: theme.spacing(0),
                '.MuiListItemText-root': {
                    '&:before': {
                        content: '""',
                        position: 'absolute',
                        top: '0',
                        right: '0',
                        height: '100%',
                        bgcolor: theme.palette.divider,
                        width: '1px',
                        zIndex: '1',
                        pointerEvents: 'none',
                    },
                    '&:nth-of-type(1) .MuiTypography-root': {
                        opacity: '0',
                        visibility: 'hidden',
                    },
                    '&:nth-of-type(2):before': {
                        display: 'none',
                    },
                },
            }) },
            React.createElement(ListItemText, null,
                React.createElement(Typography, { component: 'span' })),
            React.createElement(ListItemText, { style: { flex: '1 1 auto' } })),
        children));
});
MapTransportConditionListInnerElementType.displayName = 'MapTransportConditionListInnerElementType';
const MapTransportConditionListItemRender = ({ data, index, style }) => {
    const { items, onClick, selectedItem } = data;
    const item = items[index];
    const messages = item.messages || [];
    const isSuccess = messages.some((message) => ['guard_out8:on', 'guard_out8:off'].indexOf(message.key) !== -1);
    const isAlert = messages.some((message) => ['guard_status8:on', 'guard_status8:off'].indexOf(message.key) !== -1);
    const isWarning = messages.some((message) => ['event_id:1'].indexOf(message.key) !== -1);
    const isDanger = messages.some((message) => ['event_id:12'].indexOf(message.key) !== -1);
    return (React.createElement(ListItem, { disablePadding: true, key: index, style: style, selected: (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.datetime) === item.datetime, onClick: () => onClick(item), sx: (theme) => (Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({ '&:hover': {
                cursor: 'pointer',
            }, '&.Mui-selected': {
                bgcolor: theme.palette.primary.main + '!important',
                color: theme.palette.primary.contrastText,
                '.MuiCheckbox-root': {
                    color: theme.palette.primary.contrastText,
                    '&.Mui-checked': {
                        color: theme.palette.primary.contrastText,
                    },
                },
            }, '.MuiListItemText-root:nth-of-type(2) span:last-of-type': {
                paddingLeft: '6px',
            } }, ((items.length - (items.length - 1 - index)) % 2 === 0 && {
            bgcolor: 'background.default',
        })), (isSuccess && {
            bgcolor: '#aaffaa',
        })), (isAlert && {
            bgcolor: '#ffaaaa',
        })), (isWarning && {
            bgcolor: '#ffc107',
        })), (isDanger && {
            bgcolor: '#ec7d02',
            color: '#ffffff',
        }))) },
        React.createElement(ListItemText, { disableTypography: true },
            React.createElement(Typography, { component: 'span' }, items.length - (items.length - 1 - index))),
        React.createElement(ListItemText, { disableTypography: true },
            React.createElement(Typography, { component: 'span' }, moment(item.datetime).format('DD.MM')),
            React.createElement(Typography, { component: 'span' }, moment(item.datetime).format('HH:mm:ss')))));
};
export default MapTransportConditionList;
